/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Private functions
 */

export default styled.div`
  align-items: center;
  height: 100vh;
  overflow: auto;
  flex-direction: column;
  display: flex;

  width: 100%;
`;
